import type {
  SupplierPalletShipmentFinaliseResponseType,
  SupplierPalletShipmentFinaliseRequestType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../hooks/api/v2/apiV2Request";
import { useFirebaseUser } from "../../../hooks/useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { ServerStateKeys } from "../../../hooks/api/v2/ServerStateKeys";

export const useSellarDistributionPalletFinalise = (id: number) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SupplierPalletShipmentFinaliseRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `distribution-pallet-shipment/${id}/finalise`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as SupplierPalletShipmentFinaliseResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SellarDistributionPalletShipment,
          id,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [
          business?.id,
          ServerStateKeys.SellarDistributionPalletShipment,
        ],
      });
    },
  });
};
